export default function RightIngredientsList() {
    const ingredients = [
      "100% Whole Wheat/Millets Cakes",
      "Jaggery",
      "Couverture (Pure) Chocolate",
      "Premium Quality Butter",
      "First Quality Fruits/Nuts Toppings",
      "No Food Colors",
      "Freshly Baked Every Day",
      "100% Preservative-Free",
      "100% Vegetarian"
    ];
  
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
          <h5 className="weuse-ing-content">
            ✔ We Use
          </h5>
          
        </div>
  
        <h3 style={{ color: "#0DAF50", marginBottom: "10px" }}>Only Natural Ingredients</h3>
  
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {ingredients.map((item, index) => (
            <li key={index} style={{ marginBottom: "6px", display: "flex", alignItems: "center" }}>
              <span style={{ color: "#0DAF50", marginRight: "8px" }}>✔</span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    );
  }
  